<template>
  <editor-menu-bar
    class="bc-note-editor__menu-bar"
    :editor="editor"
    #default="{commands, getMarkAttrs, isActive}"
  >
    <note-editor-menu
      :commands="commands"
      :get-mark-attrs="getMarkAttrs"
      :is-active="isActive"
      :options="options"
      :visible-options="visibleOptions"
      #default="{
        form,
        formatText,
        isLinkDialogOpen,
        isMoreTextFormattingOptionsActive,
        isMoreTextFormattingOptionsVisible,
        isTextFormattingOptionActive,
        moreTextFormattingOptions,
        setLinkUrl,
        textFormattingOptions,
        unsetLinkUrl,
      }"
    >
      <div class="l-flex-grid l-flex-grid--v-center">
        <el-dialog
          title="Insert a URL"
          width="35%"
          :visible.sync="isLinkDialogOpen"
          :append-to-body="true"
        >
          <el-form
            :model="form"
            @submit.native.prevent="setLinkUrl"
          >
            <el-form-item
              label="URL"
              prop="url"
            >
              <el-input
                v-model="form.url"
                name="url"
                autofocus
                placeholder="Insert URL here"
                data-element="url"
                v-validate="{url: {require_protocol: true }}"
              />
            </el-form-item>
          </el-form>
          <span slot="footer">
            <el-button @click="unsetLinkUrl">
              Reset
            </el-button>
            <el-button
              type="primary"
              @click="setLinkUrl"
            >
              Confirm
            </el-button>
          </span>
        </el-dialog>
        <template
          v-for="(formatOption, index) in textFormattingOptions"
        >
          <el-tooltip
            :key="index"
            :content="formatOption.label"
            transition="none"
            placement="top"
            :open-delay="300"
          >
            <el-button
              v-test-id="'menu-bar-button'"
              :key="index"
              type="text"
              :data-test="`${formatOption.name}-button`"
              class="bc-note-editor__menu-bar-button"
              :class="{'bc-note-editor__menu-bar-button--active': isTextFormattingOptionActive(formatOption)}"
              @click="formatText(formatOption)"
              :data-element="`${formatOption.name}-format`"
            >
              <fa-icon
                class="u-text--reg"
                :icon="formatOption.icon"
              />
            </el-button>
          </el-tooltip>
        </template>
        <el-popover
          trigger="hover"
          placement="top-end"
          visible-arrow="false"
          class="u-ml2"
          popper-class="bc-note-editor__menu-bar-popover"
          v-model="isMoreTextFormattingOptionsVisible"
        >
          <div>
            <template
              v-for="(formatOption, index) in moreTextFormattingOptions"
            >
              <el-tooltip
                :key="index"
                :content="formatOption.label"
                transition="none"
                placement="top"
                :open-delay="300"
              >
                <el-button
                  v-test-id="'show-more-menu-bar-button'"
                  type="text"
                  :data-test="`${formatOption.name}-button`"
                  class="bc-note-editor__menu-bar-button"
                  :key="index"
                  :class="{'bc-note-editor__menu-bar-button--active': isTextFormattingOptionActive(formatOption)}"
                  @click="formatText(formatOption)"
                  :data-element="`${formatOption.name}-format`"
                >
                  <fa-icon
                    class="u-text--reg"
                    :icon="formatOption.icon"
                  />
                </el-button>
              </el-tooltip>
            </template>
          </div>
          <el-button
            v-test-id="'menu-bar-button'"
            v-show="moreTextFormattingOptions.length > 0"
            slot="reference"
            class="bc-note-editor__menu-bar-button"
            :class="{'bc-note-editor__menu-bar-button--active': isMoreTextFormattingOptionsActive()}"
            type="text"
            data-element="menubar-more-format-options"
          >
            <fa-icon
              class="u-text--reg"
              :icon="['far', 'ellipsis-h']"
            />
          </el-button>
        </el-popover>
      </div>
    </note-editor-menu>
  </editor-menu-bar>
</template>

<style lang="scss" src="./_note-editor.scss"></style>

<script>
import {EditorMenuBar} from 'tiptap'
import {NoteEditorMenu} from '#/notes/components/NoteEditorMenu'

export default {
  name: 'NoteEditorMenuBar',
  inject: ['$validator'],
  components: {
    EditorMenuBar,
    NoteEditorMenu
  },
  props: {
    editor: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    visibleOptions: {
      type: Number,
      default: 10
    }
  }
}
</script>
